import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-referral-dashboard',
  templateUrl: './referral-dashboard.component.html',
  styleUrls: ['./referral-dashboard.component.scss']
})
export class ReferralDashboardComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
